// «Ціни» v2 (29.10.2026): одна сторінка РДН · ВДР · БР, лінії прогнозу BASE і EXPRO.
const translations: Record<string, string> = {
  "pv2_accuracy": "Точність прогнозу",
  "pv2_accurate_hint": "точна година — похибка BASE ≤ {{rel}} % факту, але не менше {{abs}} грн",
  "pv2_accurate_hours": "точних годин",
  "pv2_after_fact": "зʼявиться, коли буде факт",
  "pv2_badge_fact": "ФАКТ",
  "pv2_band": "Межі можливої ціни 10–90 %",
  "pv2_band_title": "Показати або сховати межі можливої ціни",
  "pv2_bm": "БР",
  "pv2_br_fact": "Фактичні",
  "pv2_br_oper": "Оперативні",
  "pv2_dam": "РДН",
  "pv2_day": "Доба",
  "pv2_deviation": "Відхилення",
  "pv2_download_cards": "Завантажити показники",
  "pv2_download_hourly": "Завантажити погодинні дані",
  "pv2_empty": "Немає даних РДН за {{d}}. Ціни на завтра зʼявляються сьогодні о 12:45–13:15 за київським часом.",
  "pv2_err_base": "Похибка BASE",
  "pv2_expro_pending": "Лінія EXPRO зʼявиться після першого щоденного прогону (аналіз ExPro)",
  "pv2_hour": "Година",
  "pv2_hourly_title": "Погодинні ціни РДН",
  "pv2_idm": "ВДР",
  "pv2_idm_empty": "Немає даних ВДР за {{d}}.",
  "pv2_idm_hourly": "Погодинні ціни ВДР",
  "pv2_idm_title": "Ціни ВДР",
  "pv2_k_uah": "тис. грн",
  "pv2_line_fact": "Факт",
  "pv2_line_naive": "Ціна попередньої доби",
  "pv2_loading": "Завантаження…",
  "pv2_m_uah": "млн грн",
  "pv2_month_days": "за {{n}} діб, де є і факт, і прогноз",
  "pv2_month_sub": "індекс BASE кожної доби: факт і прогноз, зафіксований до подачі заявок",
  "pv2_month_title": "Ціни РДН за місяць",
  "pv2_mwh": "МВт·год",
  "pv2_n_days": "за {{n}} доб.",
  "pv2_naive_date": "Ціна {{d}}",
  "pv2_naive": "Ціна попередньої доби",
  "pv2_naive_title": "Ціни тієї ж години за {{d}} — базис порівняння: прогноз має бути кращим за них",
  "pv2_no_run": "немає прогнозу",
  "pv2_of_hours": "з {{n}} год",
  "pv2_of_hours_short": "{{a}} з {{n}}",
  "pv2_period_day": "За добу",
  "pv2_period_month": "За місяць",
  "pv2_q_accurate": "Точні години",
  "pv2_q_band": "У межах 10–90 %",
  "pv2_q_band_w": "У межах 10–90 % · ширина",
  "pv2_q_bess": "Цикл УЗЕ Лучок",
  "pv2_q_days": "Діб",
  "pv2_q_line": "Лінія",
  "pv2_q_mae": "Середня похибка",
  "pv2_quality_month_note": "У дужках — ціна попередньої доби на тих самих добах. Цикл УЗЕ: план за прогнозом, порахований за фактичними цінами, % — від ідеалу (план за фактом).",
  "pv2_quality_month_sub": "Кожна лінія проти ціни попередньої доби — у гривнях і годинах",
  "pv2_quality_month_title": "Якість прогнозу за місяць",
  "pv2_quality_note": "Точна година — похибка ≤ {{rel}} % факту, але не менше {{abs}} грн. Цикл УЗЕ Лучок: план заряду/розряду за прогнозом, порахований за фактичними цінами; % — від ідеального плану.",
  "pv2_quality_sub": "Кожна лінія проти ціни попередньої доби: похибка в гривнях, точні години, гроші циклу УЗЕ",
  "pv2_quality_title": "Як справдився прогноз",
  "pv2_retro": "ретро",
  "pv2_level_estimate": "оцінка рівня",
  "pv2_row_acc_base": "Точні години BASE",
  "pv2_row_acc_naive": "Точні години: ціна попередньої доби",
  "pv2_row_base": "BASE, грн/МВт·год",
  "pv2_row_base_band": "BASE, межі 10–90 %",
  "pv2_row_base_base": "BASE (прогноз), індекс доби",
  "pv2_row_dev_base": "Відхилення від BASE, %",
  "pv2_row_dev_expro": "Відхилення від EXPRO, %",
  "pv2_row_expro": "EXPRO, грн/МВт·год",
  "pv2_row_expro_base": "EXPRO (прогноз), індекс доби",
  "pv2_row_fact": "Ціна, факт",
  "pv2_row_fact_base": "Факт, індекс BASE доби",
  "pv2_row_naive": "Ціна попередньої доби",
  "pv2_row_naive_base": "Попередня доба, індекс",
  "pv2_row_volume": "Обсяг, МВт·год",
  "pv2_run_from": "від {{d}} (D+{{h}}, {{model}})",
  "pv2_sub_fact": "факт",
  "pv2_sub_nofact": "факт зʼявиться після торгів",
  "pv2_uah": "грн",
  "pv2_unit": "грн/МВт·год",
  "pv2_volume": "Обсяг",
  "pv2_weighted": "Середньозважена ціна",
  "pv2_x_all": "Весь період",
  "pv2_x_bad_range": "Дата «з» має бути не пізніше за «по»",
  "pv2_x_busy": "Формуємо файл за {{n}} діб…",
  "pv2_x_cancel": "Скасувати",
  "pv2_x_clock": "Час",
  "pv2_x_close": "Закрити",
  "pv2_x_date": "Дата",
  "pv2_x_dev_base": "Відхилення від BASE, %",
  "pv2_x_download": "Завантажити .xlsx",
  "pv2_x_fact": "факт",
  "pv2_x_failed": "Не вдалося сформувати файл. Спробуйте ще раз",
  "pv2_x_from": "з",
  "pv2_x_h_day": "обрана доба",
  "pv2_x_h_month": "місяць обраної доби",
  "pv2_x_h_year": "рік обраної доби",
  "pv2_x_model_base": "Модель BASE",
  "pv2_x_model_expro": "Модель EXPRO",
  "pv2_x_nodata": "Немає даних {{m}} за вибраний період",
  "pv2_x_ok": "Файл сформовано, завантаження почалося",
  "pv2_x_p_custom": "Свій період",
  "pv2_x_p_day": "Доба",
  "pv2_x_p_month": "Місяць",
  "pv2_x_p_year": "Рік",
  "pv2_x_period": "Період",
  "pv2_x_price": "Ціна, грн/МВт·год",
  "pv2_x_sub_cards_dam": "Ціни {{m}} (факт і прогнози BASE / EXPRO, ОРЕЄ): середньозважена, BASE, PEAK, OFFPEAK за кожну добу",
  "pv2_x_sub_cards_idm": "Ціни {{m}} (факт, ОРЕЄ): середньозважена, BASE, PEAK, OFFPEAK за кожну добу",
  "pv2_x_sub_hourly_dam": "Погодинні ціни та обсяги {{m}}: факт, BASE (з межами), EXPRO, ціна попередньої доби",
  "pv2_x_sub_hourly_idm": "Погодинні ціни та обсяги {{m}} (факт, ОРЕЄ)",
  "pv2_x_title": "Завантажити в Excel",
  "pv2_x_to": "по",
  "pv2_x_too_long": "Забагато діб (макс. {{n}})",
};

export default translations;
